export default __webpack_public_path__ + "static/media/designPublicReview.7415cc8e.svg";